import moment from "moment";

export default {

    methods: {
        checkForSelectedCalendar() {},
        checkActiveWeek(week) {
            let week_start = this.getDayIndexInMonth(week, 1, this.startMonthDay);
            let week_end = this.getDayIndexInMonth(week, 7, this.startMonthDay);
            if (week_start < 1) {
                week_start = 1;
            }

            let dateStart = moment(
                Date.UTC(this.activeYearStart, this.activeMonthStart, week_start)
            );
            let dateEnd = moment(
                Date.UTC(this.activeYearStart, this.activeMonthStart, week_end)
            );

            let monthObj = moment(
                Date.UTC(this.activeYearStart, this.activeMonthStart, 1)
            );

            if (dateEnd.isAfter(monthObj.endOf("month"))) {
                dateEnd = monthObj.endOf("month");
            }
            return moment().isBetween(dateStart, dateEnd);
        },

        checkIfNextWeek(week) {
            let week_start = this.getDayIndexInMonth(week, 1, this.startMonthDay);
            let week_end = this.getDayIndexInMonth(week, 7, this.startMonthDay);
            if (week_start < 1) {
                week_start = 1;
            }

            let dateStart = moment(
                Date.UTC(this.activeYearStart, this.activeMonthStart, week_start)
            );
            let dateEnd = moment(
                Date.UTC(this.activeYearStart, this.activeMonthStart, week_end)
            );

            let monthObj = moment(
                Date.UTC(this.activeYearStart, this.activeMonthStart, 1)
            );

            if (dateEnd.isAfter(monthObj.endOf("month"))) {
                dateEnd = monthObj.endOf("month");
            }
            if (moment(moment().add("7", "days")).isBetween(dateStart, dateEnd)) {
            }
            return moment(moment().add("7", "days")).isBetween(dateStart, dateEnd);
        },

        checkIfPrevWeek(week) {
            let week_start = this.getDayIndexInMonth(week, 1, this.startMonthDay);
            let week_end = this.getDayIndexInMonth(week, 7, this.startMonthDay);
            if (week_start < 1) {
                week_start = 1;
            }

            let dateStart = moment(
                Date.UTC(this.activeYearStart, this.activeMonthStart, week_start)
            );
            let dateEnd = moment(
                Date.UTC(this.activeYearStart, this.activeMonthStart, week_end)
            );

            let monthObj = moment(
                Date.UTC(this.activeYearStart, this.activeMonthStart, 1)
            );

            if (dateEnd.isAfter(monthObj.endOf("month"))) {
                dateEnd = monthObj.endOf("month");
            }
            return moment(moment().subtract("1", "week")).isBetween(
                dateStart,
                dateEnd
            );
        },

        checkIfCurrentWeek(week) {
            let week_start = this.getDayIndexInMonth(week, 1, this.startMonthDay);
            let week_end = this.getDayIndexInMonth(week, 7, this.startMonthDay);
            if (week_start < 1) {
                week_start = 1;
            }

            let dateStart = moment(
                Date.UTC(this.activeYearStart, this.activeMonthStart, week_start)
            );
            let dateEnd = moment(
                Date.UTC(this.activeYearStart, this.activeMonthStart, week_end)
            );

            let monthObj = moment(
                Date.UTC(this.activeYearStart, this.activeMonthStart, 1)
            );

            if (dateEnd.isAfter(monthObj.endOf("month"))) {
                dateEnd = monthObj.endOf("month");
            }
            return moment().isBetween(
                moment(dateStart).add("1", "days"),
                moment(dateEnd).add("1", "days")
            );
        },

        checkIfNextMonday(i) {
            return i + 1 === 2;
        },

        getHash() {
            return (
                Math.floor(Math.random() * 10000) +
                1 +
                Math.floor(Math.random() * 10000) +
                1
            );
        }
    }
};
